module.exports = __webpack_public_path__ + "media/CICD.1bba9b969b28e542a6de8eb0d9fc2151.svg";